const NotFound = () => {
	return (
		<>	
			<h1> Ohho!!! The page you are looking does not exist </h1>
		</>
	);

}

export default NotFound;